/* eslint-disable no-restricted-globals */

import { landingLayer, mainSurveyLayer } from "@pageDefinitions/goto/constants";
import { captureException } from "src/utils/error";
import goto from ".";
import {
  isInsideAndroidWebView,
  isInsideIOSWebKit,
  pageSetPushReroll,
} from "./utils";
import {
  getAndroidMessageHandlers,
  getIOSMessageHandlers,
} from "src/utils/in-app/messageHandlers";
import {
  getHmRouteId,
  getMeristemContext,
  getRouteId,
} from "@utils/meristemContext";
import { isHM } from "src/utils/userSegment";
import { updateForwardedParams, updateURLParams } from "src/utils/urlParams";
import { reroll } from "../components/PageSetRouter";

export function isBuyflow() {
  return ["landing", "main-survey"].includes(getMeristemContext().context_type);
}

export const linkTo = {
  mainSurvey() {
    return "/ps/main-survey";
  },
};

const hmRouteSwitch = (
  currentRoute: string = getRouteId(),
  newRoute: string = getHmRouteId()
) => {
  if (currentRoute !== newRoute) {
    // Ensure that if we come back, the route is preserved instead of using the HM one
    updateURLParams({ route: currentRoute });
    updateForwardedParams({ route: newRoute });
  }
};

export default {
  // Landing
  landing() {
    goto.layer(landingLayer);
  },
  hmLanding() {
    hmRouteSwitch();
    reroll(`/programs/mood/${getHmRouteId()}`);
  },
  // Survey
  async mainSurvey(replaceHistory = false, routeId?: string) {
    return goto.layer(mainSurveyLayer, null, replaceHistory, routeId);
  },
  // HM Survey
  async hmMainSurvey() {
    hmRouteSwitch();
    return goto.mainSurvey();
  },
  /**
   * This is intended mostly as a stopgap and may not work for all future implementations.
   * @deprecated Use page set navigation instead.
   */
  async surveyQuestion(question: string) {
    if (!question) {
      goto.mainSurvey();
      return;
    }

    pageSetPushReroll(
      isHM() ? `/survey/hm/${question}` : `/survey/${question}`
    );
  },

  async choosePlan() {
    pageSetPushReroll(isHM() ? "/survey/hm/choosePlan" : "/survey/choosePlan");
  },

  nativeBuyflowExit() {
    if (isInsideIOSWebKit()) {
      try {
        const messageHandlers = getIOSMessageHandlers();
        messageHandlers?.buyflowExit?.postMessage({});
        return true;
      } catch (err) {
        // istanbul ignore next Error handling
        captureException(err, "nativeBuyflowExit.ios");
      }
    }
    if (isInsideAndroidWebView()) {
      try {
        const messageHandlers = getAndroidMessageHandlers();
        if (messageHandlers && messageHandlers.buyflowExit) {
          messageHandlers.buyflowExit();
          return true;
        }
      } catch (err) {
        // istanbul ignore next Error handling
        captureException(err, "nativeBuyflowExit.android");
      }
    }

    // eslint-disable-next-line no-console
    console.error("nativeBuyflowExit: no message handler found");

    // go to the landing page in case native buyflow exit fails
    goto.landing();
    return false;
  },
  nativeWebviewExit() {
    if (isInsideIOSWebKit()) {
      const webviewExit = getIOSMessageHandlers()?.webviewExit;
      webviewExit?.postMessage({});
      return !!webviewExit;
    }
    if (isInsideAndroidWebView()) {
      const webviewExit = getAndroidMessageHandlers()?.webviewExit;
      if (webviewExit) {
        webviewExit();
      }
      return !!webviewExit;
    }
    return false;
  },
  closeInAppContentScreen() {
    // score=1 will mark the in-app task as complete
    window.location.href = "https://unknown.noom.com?score=1&close=1";
  },
  closeInAppWebview() {
    // this is different from the above as it just closes the webview without marking a task as complete
    window.location.href = "https://unknown.noom.com/?close=1";
  },
};
